module.exports = __webpack_public_path__ + "media/images/users/women-d3a399f1c3f39c3d1294b197fccfdf82.svg";